import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../assets/logo.png'
import Timer from '../../components/Timer/Timer'
import { UPDATE_CURRENT_LANGUAGE } from '../../constants/actionTypes'
import Button from '../Button/Button'
import ProgressBar from '../ProgressBar/ProgressBar'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'
import stopwatch from '../../assets/stopwatch.svg'
import './Header.css'
import HeaderTitleDropdown from './HeaderTitleDropdown'
import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

const mapStateToProps = (state) => {
    return {
        completion: state.completion,
        time_completion: state.t,
        testData: state.instructions,
        hideTimer: state.timer,
        queryparam: state.queryparam,
        current_question: state.current_question,
        testStatus: state.testStatus,
        calculated_time_left: state.calculated_time_left,
        current_language: state.current_language,
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateCurrentLanguage: (payload) => {
        dispatch({ type: UPDATE_CURRENT_LANGUAGE, payload })
    },
})
export const selectLanguage = (lng) => {
    switch (lng) {
        case 'en':
            return 'English(En)'
        case 'hi':
            return 'Hindi(Hi)'
        case 'gu':
            return 'Gujarati(Gu)'
        default:
            return 'Unsupported language'
    }
}
const Header = (props) => {
    const [timer, setTimer] = useState()
    const [showHeader, setShowHeader] = useState(true)
    const [dropdown, setDropdown] = useState(false)
    const location = useLocation()
    let timerAddress = timer
    const wrapperRef = useRef(null)
    const { t, i18n } = useTranslation()

    if (props.time_completion === -1) {
        clearInterval(timerAddress)
    }
    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setDropdown(false)
        }
    }

    useEffect(() => {
        if (location.pathname === '/success') {
            setShowHeader(false)
        } else {
            setShowHeader(true)
        }
    }, [location.pathname])

    const handleLangChange = (evt, language) => {
        const lang = evt.target.value
        trackEvent(EVENT_NAMES.TESTPLAYER_LANGUAGE_SELECTION, '', {
            [ANALYTICS_KEYS.LANGUAGE]: selectLanguage(lang),
        })

        trackEvent(
            EVENT_NAMES.TAP_LANGUAGE_INSTRUCTION_WEB,
            'User changes the language on the instruction screen',
            {
                [ANALYTICS_KEYS.LANGUAGE]: selectLanguage(lang),
                [ANALYTICS_KEYS.EXTERNAL_ID]:
                    props.current_question?.question?.questionExternalId,
                [ANALYTICS_KEYS.QUESTION_ID]:
                    props.current_question?.question?.questionid,
                [ANALYTICS_KEYS.SECTION_NAME]: props.current_question?.subject,
                [ANALYTICS_KEYS.USER_TEST_ID]:
                    props.testStatus?.testStatus?.data?.userTestId,
            },
        )

        if (!props.isPreview) {
            trackEvent(
                EVENT_NAMES.TAP_LANGUAGE_TEST_START_WEB,
                'User selects a language from the dropdown during the test',
                {
                    [ANALYTICS_KEYS.LANGUAGE]: selectLanguage(lang),
                    [ANALYTICS_KEYS.EXTERNAL_ID]:
                        props.current_question?.question?.questionExternalId,
                    [ANALYTICS_KEYS.QUESTION_ID]:
                        props.current_question?.question?.questionid,
                    [ANALYTICS_KEYS.SECTION_NAME]: props.current_question?.subject,
                    [ANALYTICS_KEYS.USER_TEST_ID]:
                        props.testStatus?.testStatus?.data?.userTestId,
                },
            )
        }

        props.updateCurrentLanguage(lang)
        i18n.changeLanguage(lang)
        setDropdown(false)
    }

    const handleLangDropdownClick = () => {
        setDropdown(!dropdown)
    }

    if (!showHeader) {
        return null
    }

    return (
        <header>
            {props?.hideTimer?.hideTimer !== false && (
                <div className="header" style={props.style}>
                    <HeaderTitleDropdown
                        selectLanguage={selectLanguage}
                        handleLangChange={handleLangChange}
                        showToggle={false}
                    ></HeaderTitleDropdown>
                </div>
            )}
            {!props?.hideTimer?.hideTimer ? (
                <div className="header" style={props.style}>
                    <HeaderTitleDropdown
                        selectLanguage={selectLanguage}
                        handleLangChange={handleLangChange}
                        showToggle={true}
                    ></HeaderTitleDropdown>

                    <div className="progressbar">
                        {!props.isPreview ? (
                            <div className="timer-progressbar">
                                <div className="timer-stopwatch">
                                    <img
                                        className="stopwatch-img"
                                        alt="stopwatch"
                                        src={stopwatch}
                                    ></img>
                                    <Timer
                                        timerAddress={timer}
                                        class={'timer'}
                                        setTimer={setTimer}
                                    />
                                </div>
                                <ProgressBar
                                    done={props.completion.completion}
                                    opacity={'1'}
                                />
                            </div>
                        ) : null}
                        <div className="completion">
                            {!props.isPreview ? (
                                <span className="completion-value">
                                    {props.completion.completion}%
                                </span>
                            ) : null}
                            <Link to="/submit">
                                <Button
                                    onClick={async () =>
                                        !props.isPreview &&
                                        trackEvent(
                                            EVENT_NAMES.TAP_END_TEST_WEB,
                                            'User taps on the end test button ',
                                            {
                                                [ANALYTICS_KEYS.SUCCESS]: true,
                                                [ANALYTICS_KEYS.QUESTION_ID]:
                                                    props.current_question.question
                                                        .questionid,
                                                [ANALYTICS_KEYS.SECTION_NAME]:
                                                    props.current_question.subject[
                                                        props.current_language
                                                    ],
                                                [ANALYTICS_KEYS.USER_TEST_ID]:
                                                    props.testStatus?.testStatus
                                                        ?.data?.userTestId,
                                                [ANALYTICS_KEYS.DISCONNECTION_TIME]:
                                                    props.queryparam
                                                        .disconnect_time * 60,
                                                [ANALYTICS_KEYS.EXTERNAL_ID]:
                                                    props.current_question.question
                                                        .questionExternalId,
                                            },
                                        )
                                    }
                                    name={'End Test'}
                                    classes={
                                        isInPhoneOrTablet()
                                            ? 'is_phone'
                                            : 'is_phone_not'
                                    }
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="timer-progressbar-blank"></div>
            )}
        </header>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
